import { IdgProvider } from './context/IdgContext';
import Idg from './Idg';

function Form20270({ handleSubmit, isPending, language }) {
    return (
        <IdgProvider>
            <Idg
                handleSubmit={handleSubmit}
                isPending={isPending}
                language={language}
            />
        </IdgProvider>
    );
}

export default Form20270;
